export const AGENT_URL = 'http://agent.8876684.com/ ' // 代理登录
export const AGENT_URL_REGISTER = 'https://agent.8876684.com/#agent/register' // 代理注册
export const WEBSITE = 'https://10812.com' // 导航站
// export const HOTEL = 'https://www.galaxymacau.com/cn/' // 酒店介绍
export const APP_DOWNLOAD = 'https://js9410.com' // 下载地址



// WEBPACK FOOTER //
// ./src/pages/build901/assets/js/domian.js